import type { AuthConfigNanoId } from '@composio/types'
import Head from 'next/head'
import { useRouter } from 'next/router'
import { useQuery } from '@tanstack/react-query'

import { getAuthConfigsByNanoid } from '~/generated/client'
import ConnectorPage from '~/ui/screens/connector'
import { withAuth } from '~/utils/hoc'

export const useGetConnectorInfo = (authConfigId?: AuthConfigNanoId) => {
  const { data, isSuccess, isError, isLoading, refetch } = useQuery(
    ['connector', authConfigId],
    () =>
      getAuthConfigsByNanoid({
        nanoid: authConfigId!,
      }),
    {
      enabled: !!authConfigId,
      staleTime: 1000 * 60 * 5,
      refetchOnMount: 'always',
    },
  )

  return {
    data,
    isSuccess,
    isError,
    isLoading,
    refetch,
  }
}

function Page() {
  const { query } = useRouter()

  const { data: connectorInfo } = useGetConnectorInfo(
    query.connectorId as AuthConfigNanoId,
  )

  return (
    <>
      <Head>
        <title>{connectorInfo?.name}</title>
      </Head>
      <ConnectorPage />
    </>
  )
}

export default withAuth(Page)
